module.exports = __webpack_public_path__ + "static/img/cygn7.06818b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/cygn7.png
// module id = 316
// module chunks = 0